import React from 'react';
import { MockupCrop } from '../MockupCrop';
import { Accent } from './SectionHeading';
import { bonuses } from '../../data/content';

/** Section 8 — extra bonuses, deliberately smaller than the core volumes. */
export function BonusesSection() {
  return <section aria-labelledby="bonus-heading" className="border-t border-brand-plum/10 bg-brand-lavender px-5 py-16 lg:px-8 lg:py-24" data-id="element-43" data-mp="16j4whozw7cor">
      <div className="mx-auto max-w-6xl" data-id="element-44" data-mp="wms2eq0fqwth">
        <div className="mx-auto max-w-2xl text-center" data-id="element-45" data-mp="wp5xuzz12b1k">
          <p className="mx-auto w-fit rounded-full bg-brand-plum px-4 py-1.5 font-body text-[11px] font-bold uppercase tracking-[0.18em] text-white" data-id="element-46" data-mp="11n7gxkwgead1">
            Plus — 5 Extra Bonuses
          </p>
          <h2 id="bonus-heading" className="mt-5 font-display text-[2.1rem] font-bold leading-[1.08] text-brand-charcoal sm:text-[2.75rem]" data-id="element-47" data-mp="smho8q2hp03j">
            Everything You Need to Make Teaching <Accent data-id="element-48" data-mp="2my68n7rhpuvb">Even Easier.</Accent>
          </h2>
        </div>

        <ol className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5" role="list" data-id="element-49" data-mp="1k7bxk49h0l8m">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-[16px] bg-white p-3 pb-5" data-id="element-50" data-mp="1g5gw8zrji7uu">
              <MockupCrop crop={bonus.crop} alt={`${bonus.number} cover — ${bonus.title}`} className="rounded-[10px]" data-id="element-51" data-mp="1tx5b3at6bafi" />
              <p className="mt-4 px-1 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-plum" data-id="element-52" data-mp="1p0n7wfdhrk5a">
                {bonus.number}
              </p>
              <h3 className="mt-1.5 px-1 font-body text-[14px] font-semibold leading-snug text-brand-charcoal lg:min-h-[3.9rem]" data-id="element-53" data-mp="x8pkdbebuv0t">
                {bonus.title}
              </h3>
              <p className="mt-1.5 px-1 text-[13px] leading-relaxed text-brand-charcoal/65" data-id="element-54" data-mp="167t48hlbjegd">{bonus.description}</p>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-55" data-mp="2mof71ew40vfi">
          These bonuses <strong className="font-semibold text-brand-charcoal" data-id="element-56" data-mp="2po78nariar9d">expand</strong> the system. The 6
          professional volumes remain the foundation of Makeup Instructor Ready.
        </p>
      </div>
    </section>;
}